import { render, staticRenderFns } from "./groupNotification.vue?vue&type=template&id=cf61d334&scoped=true"
import script from "./groupNotification.vue?vue&type=script&lang=js"
export * from "./groupNotification.vue?vue&type=script&lang=js"
import style0 from "./groupNotification.vue?vue&type=style&index=0&id=cf61d334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf61d334",
  null
  
)

export default component.exports